import { z } from "zod";
import type { Operation } from "../types";
import { idNumericParams } from "./_common";

export const jobSourceSchema = z.object({
  id: z.number(),
  workspace_id: z.number(),
  slug: z.string(),
  name: z.string(),
  archived_at: z.string().nullable(),
  created_at: z.string(),
});
export type JobSourceShape = z.infer<typeof jobSourceSchema>;

export const sourcesList: Operation<void, void, void, JobSourceShape[]> = {
  method: "GET",
  path: () => "/hiring/api/sources",
  response: z.array(jobSourceSchema),
};

export const sourceCreateBody = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
});

// coverage-ignore: mutate ops deferred on Hono (hiring.ts NOTE); list is mounted
export const sourcesCreate: Operation<
  void,
  void,
  z.infer<typeof sourceCreateBody>,
  JobSourceShape
> = {
  method: "POST",
  path: () => "/hiring/api/sources",
  body: sourceCreateBody,
  response: jobSourceSchema,
  invalidates: [sourcesList],
};

// coverage-ignore: mutate ops deferred on Hono (hiring.ts NOTE); list is mounted
export const sourcesArchive: Operation<{ id: number }, void, void, { id: number }> = {
  method: "DELETE",
  path: ({ id }) => `/hiring/api/sources/${id}`,
  params: idNumericParams,
  response: z.object({ id: z.number() }),
  invalidates: [sourcesList],
};

export const hiringSources = {
  list: sourcesList,
  create: sourcesCreate,
  archive: sourcesArchive,
};
